var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenWaveAnim(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 50,
    r: 4,
    fill: "#00e3b4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "34;66;34",
    times: "0;0.5;1",
    dur: "1.408450704225352s",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "0s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 61.31370849898476,
    r: 4,
    fill: "#29c4a4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "34;66;34",
    times: "0;0.5;1",
    dur: "1.408450704225352s",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "-0.176056338028169s",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 66,
    r: 4,
    fill: "#82dbb8"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "34;66;34",
    times: "0;0.5;1",
    dur: "1.408450704225352s",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "-0.352112676056338s",
    repeatCount: "indefinite"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 61.31370849898476,
    r: 4,
    fill: "#00e3b4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "34;66;34",
    times: "0;0.5;1",
    dur: "1.408450704225352s",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "-0.528169014084507s",
    repeatCount: "indefinite"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 50,
    r: 4,
    fill: "#00e3b4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "34;66;34",
    times: "0;0.5;1",
    dur: "1.408450704225352s",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "-0.704225352112676s",
    repeatCount: "indefinite"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 38.68629150101524,
    r: 4,
    fill: "#29c4a4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "34;66;34",
    times: "0;0.5;1",
    dur: "1.408450704225352s",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "-0.880281690140845s",
    repeatCount: "indefinite"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 34,
    r: 4,
    fill: "#82dbb8"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "34;66;34",
    times: "0;0.5;1",
    dur: "1.408450704225352s",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "-1.056338028169014s",
    repeatCount: "indefinite"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 38.68629150101523,
    r: 4,
    fill: "#00e3b4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "34;66;34",
    times: "0;0.5;1",
    dur: "1.408450704225352s",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "-1.232394366197183s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenWaveAnim);
export default __webpack_public_path__ + "static/media/green-wave-anim.fb1377c50551621211e35b6cf924fda1.svg";
export { ForwardRef as ReactComponent };